window.compatible_config = {
  "panels": {
    "S1": {
      "name": "100W Solar Panel",
      "voltage_range": "17V–22V",
      "current": "5.8A",
      "type": "fixed"
    },
    "S2": {
      "name": "200W Folding Solar Panel",
      "voltage_range": "20.4V",
      "current": "11.7A",
      "type": "folding"
    },
    "S3": {
      "name": "400W Folding Solar Panel",
      "voltage_range": "39.77V",
      "current": "12.21A",
      "type": "folding"
    },
    "S4": {
      "name": "440W Solar Panel",
      "voltage_range": "37.5V",
      "current": "13.05A",
      "type": "folding"
    }
  },
  "configurations": {
    "SLA1800": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 9, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 18, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S3":[],
      "S4":[]
    },
    "SLA1800-Battery": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 9, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 18, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S3":[],
      "S4":[]
    },
    "SLA3600": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "C2", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 9, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 18, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S3":[],
      "S4":[]
    },
    "SLA3600-Battery": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "C2", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 9, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 18, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S3":[],
      "S4":[]
    },
    "Lithium1800": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 6, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        // { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 9, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 18, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ]
    },
    "Lithium3600": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 6, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        // { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 9, "conector": "C2", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 18, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C3", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C3", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ]
    },
    "Lithium3600-Battery": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 6, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        // { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 9, "conector": "C2", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 18, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ]
    },
    "Lithium6000": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 6, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        // { "panel_qty": 8, "conector": "C1", "conector_qty": 2, "cable":"CAB","cable_qty":2, "res":"YES" },
        { "panel_qty": 9, "conector": "C2", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 12, "conector": "C1", "conector_qty": 2, "cable":"CAB","cable_qty":2, "res":"YES" },
        { "panel_qty": 18, "conector": "C2", "conector_qty": 2, "cable":"CAB","cable_qty":2, "res":"YES" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":2, "res":"YES" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":2, "res":"YES" },
        { "panel_qty": 8, "conector": "C1", "conector_qty": 2, "cable":"CAB","cable_qty":2, "res":"YES" }
      ],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":2, "res":"YES" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":2, "res":"YES" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ]
    },
    "Lithium6000-Battery": {
      "S1": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 6, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        // { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 9, "conector": "C2", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 18, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S2": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 3, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C1", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 6, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ]
    },
    "SLA7200": {
      "S1":[],
      "S2":[],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C3", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C3", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ]
    },
    "SLA7200-Battery": {
      "S1":[],
      "S2":[],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C3", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 4, "conector": "C3", "conector_qty": 1, "cable":"CAB","cable_qty":1, "res":"YES" },
        { "panel_qty": 8, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 12, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 24, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ]
    },
    "MyGrid10K": {
      "S1":[],
      "S2":[],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "C4", "conector_qty": 1, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 8, "conector": "C4", "conector_qty": 2, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 12, "conector": "C4", "conector_qty": 3, "cable":"","cable_qty":0, "res":"YES" },
        // { "panel_qty": 16, "conector": "C4", "conector_qty": 4, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 24, "conector": "C4", "conector_qty": 6, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "C4", "conector_qty": 1, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 8, "conector": "C4", "conector_qty": 2, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 12, "conector": "C4", "conector_qty": 3, "cable":"","cable_qty":0, "res":"YES" },
        // { "panel_qty": 16, "conector": "C4", "conector_qty": 4, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 24, "conector": "C4", "conector_qty": 6, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 36, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" }
      ]
    },
    "15K": {
      "S1":[],
      "S2":[],
      "S3": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "C4", "conector_qty": 1, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 8, "conector": "C4", "conector_qty": 2, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 12, "conector": "C4", "conector_qty": 3, "cable":"","cable_qty":0, "res":"YES" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 24, "conector": "C4", "conector_qty": 6, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 36, "conector": "C4", "conector_qty": 9, "cable":"","cable_qty":0, "res":"YES" }
      ],
      "S4": [
        { "panel_qty": 1, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 2, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"NO" },
        { "panel_qty": 4, "conector": "C4", "conector_qty": 1, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 8, "conector": "C4", "conector_qty": 2, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 12, "conector": "C4", "conector_qty": 3, "cable":"","cable_qty":0, "res":"YES" },
        // { "panel_qty": 16, "conector": "", "conector_qty": 0, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 24, "conector": "C4", "conector_qty": 6, "cable":"","cable_qty":0, "res":"YES" },
        { "panel_qty": 36, "conector": "C4", "conector_qty": 9, "cable":"","cable_qty":0, "res":"YES" }
      ]
    }
  }
};

async function addToCartFromForm(form, triggerButton = null) {
  if (!form || !(form instanceof HTMLFormElement)) {
    console.error('addToCartFromForm: invalid form element');
    return;
  }

  const button = triggerButton || form.querySelector('[type="submit"]');
  if (!button || button.getAttribute('aria-disabled') === 'true') {
    return;
  }

  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');

  const cartIcon = button.querySelector('.cart-icon');
  const spinner = button.querySelector('.loading__spinner');

  if (cartIcon) cartIcon.classList.add('hidden');
  if (spinner) spinner.classList.remove('hidden');

  const formData = new FormData(form);
  const urlEncodedBody = new URLSearchParams(formData).toString();

  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: urlEncodedBody,
  };

  if (cart && typeof cart.getSectionsToRender === 'function') {
    config.body += '&' + new URLSearchParams({
      sections: cart.getSectionsToRender().map(s => s.id).join(','),
      sections_url: window.location.pathname.includes('/products/') &&
                   window.location.pathname.toLowerCase().includes('cart')
        ? (window.routes?.cart_url || '/cart')
        : window.location.pathname
    }).toString();

    if (typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }
  }

  let product_list = [];
  const productFormContainer = form.closest('.product__info-container');
  if (productFormContainer) {
    productFormContainer.querySelectorAll('.sales-activities .product-item[data-choose="true"]').forEach(item => {
      const id = item.getAttribute('data-product-id');
      if (id) product_list.push(id);
    });
  }

  try {
    if (product_list.length > 0) {
      const extraResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: product_list.map(id => ({ id: parseInt(id), quantity: 1 })),
          sections: 'cart-drawer,cart-icon-bubble',
        }),
      });

      if (!extraResponse.ok) {
        console.warn('Extra items add failed, continuing with main item...');
      }
    }

    const response = await fetch('/cart/add.js', config);

    if (response.headers.get('content-type')?.includes('text/html')) {
      const html = await response.text();
      throw new Error(`Unexpected HTML response: ${html.substring(0, 200)}...`);
    }

    const json = await response.json();

    if (json.status) {
      const soldOutMessage = button.querySelector('.sold-out-message');
      if (soldOutMessage) {
        button.setAttribute('aria-disabled', 'true');
        if (cartIcon) cartIcon.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
      }
      console.error('Cart add error:', json.description || json.message);
      return;
    }

    if (cart && json.sections?.['cart-drawer']) {
      const temp = document.createElement('div');
      temp.innerHTML = json.sections['cart-drawer'];

      const newCartContent = temp.querySelector('cart-drawer')?.innerHTML;
      if (newCartContent) {
        cart.innerHTML = newCartContent;
        cart.classList.remove('is-empty');

        if (typeof Swiper !== 'undefined') {
          const swiperEl = cart.querySelector('.cart_mySwiper');
          if (swiperEl?.swiper) {
            swiperEl.swiper.destroy(true, true);
            new Swiper(".cart_mySwiper", {});
          }
        }

        setTimeout(() => {
          if (typeof cart.open === 'function') cart.open();
        }, 50);
      }
    }

  } catch (error) {
    console.error('addToCartFromForm error:', error);
  } finally {
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');

    if (cartIcon) cartIcon.classList.remove('hidden');
    if (spinner) spinner.classList.add('hidden');
  }
}

(function () {
  const globalConfig = window.compatible_config;
  if (!globalConfig || !globalConfig.panels || !globalConfig.configurations) {
    console.error('compatible_config is missing or invalid.');
    return;
  }

  const connectors = window.compatible_connectors || {};
  const cables = window.compatible_cables || {};

  if (Object.keys(connectors).length === 0 && Object.keys(cables).length === 0) {
    console.warn('No compatible connectors or cables found in window.compatible_connectors / window.compatible_cables');
  }

  const calcContainers = document.querySelectorAll('.calc-compatible');
  if (calcContainers.length === 0) return;

  const PANEL_KEYS = ['S1', 'S2', 'S3', 'S4'];

  calcContainers.forEach(function (container) {
    const productType = container.dataset.productType;
    const configurations = globalConfig.configurations[productType];
    if (!configurations) {
      console.warn(`No config for product type: ${productType}`);
      return;
    }

    const panelTypeSelect = container.querySelector('.panel-type');
    const panelQtySelect = container.querySelector('.panel-qty');
    const resEl = container.querySelector('.res');
    const resBuyEl = container.querySelector('.res-buy');

    const lastSelectedQty = {};

    function initPanelType() {
      panelTypeSelect.innerHTML = '';

      PANEL_KEYS.forEach(key => {
        const panel = globalConfig.panels[key];
        const configList = configurations[key];

        const hasValidQty = Array.isArray(configList) && configList.some(item => 
          typeof item.panel_qty === 'number' || 
          (typeof item.panel_qty === 'string' && !isNaN(parseInt(item.panel_qty, 10)))
        );

        if (panel) {
          const opt = document.createElement('option');
          opt.value = key;
          if (hasValidQty) {
            opt.textContent = panel.name;
            opt.disabled = false;
          } else {
            opt.textContent = `${panel.name} (Not Compatible)`;
            opt.disabled = true;
          }
          panelTypeSelect.appendChild(opt);
        }
      });

      let firstEnabledIndex = -1;
      for (let i = 0; i < panelTypeSelect.options.length; i++) {
        if (!panelTypeSelect.options[i].disabled) {
          firstEnabledIndex = i;
          break;
        }
      }

      if (firstEnabledIndex !== -1) {
        panelTypeSelect.selectedIndex = firstEnabledIndex;
        updatePanelQty(panelTypeSelect.value);
      } else {
        panelQtySelect.innerHTML = '';
        renderResult();
      }
    }

    function updatePanelQty(panelType) {
      const previousQty = lastSelectedQty[panelType] || null;
      panelQtySelect.innerHTML = '';

      const list = configurations[panelType];
      const validQtys = new Set();

      if (Array.isArray(list) && list.length > 0) {
        list.forEach(item => {
          const qty = String(item.panel_qty);
          validQtys.add(qty);

          const opt = document.createElement('option');
          opt.value = qty;
          opt.textContent = `${qty}`;
          opt.dataset.conector = item.conector || '';
          opt.dataset.conectorQty = item.conector_qty || 0;
          opt.dataset.cable = item.cable || '';
          opt.dataset.cableQty = item.cable_qty || 0;
          opt.dataset.res = item.res || 'NO';

          panelQtySelect.appendChild(opt);
        });

        if (previousQty && validQtys.has(previousQty)) {
          panelQtySelect.value = previousQty;
        } else if (panelQtySelect.options.length > 0) {
          panelQtySelect.selectedIndex = 0;
        }
      }

      renderResult();
    }

    function renderResult() {
      const panelType = panelTypeSelect.value;
      const qtyOption = panelQtySelect.selectedOptions[0];
      const calcResultEl = container.querySelector('.calc-result');

      if (!panelType || !qtyOption) {
        calcResultEl.classList.remove('yes');
        return;
      }

      const resValue = qtyOption.dataset.res || 'NO';
      if (resValue === 'YES') {
        calcResultEl.classList.add('yes');
      } else {
        calcResultEl.classList.remove('yes');
      }

      const conector = qtyOption.dataset.conector || '';
      const conectorQty = parseInt(qtyOption.dataset.conectorQty, 10) || 0;
      const cable = qtyOption.dataset.cable || '';
      const cableQty = parseInt(qtyOption.dataset.cableQty, 10) || 0;

      const forms = [];

      if (resValue === 'YES') {
        if (conector && conectorQty > 0) {
          const conn = connectors[conector];
          if (conn && conn.variant) {
            forms.push(createForm(conn.variant, conectorQty, conn.name, conn.price, 'connector',conn.image));
          } else {
            console.warn(`Connector "${conector}" not found in window.compatible_connectors`);
          }
        }

        if (cable && cableQty > 0) {
          const cab = cables[cable];
          if (cab && cab.variant) {
            forms.push(createForm(cab.variant, cableQty, cab.name, cab.price, 'cable',cab.image));
          } else {
            console.warn(`Cable "${cable}" not found in window.compatible_cables`);
          }
        }
      }

      if (forms.length > 0) {
        const titleHTML = '<div class="res-buy-title">Required Accessories.</div>';
        resBuyEl.innerHTML = titleHTML + forms.join('');
      } else {
        resBuyEl.innerHTML = '';
      }
    }

    function createForm(variantId, quantity, name, price, type, imageUrl = null) {
      const pricePart = price ? ` ${price}` : '';
      let itemTitle = '';
      if (type === 'connector') {
        itemTitle = '<div class="item-title">Solar Panel Connector</div>';
      } else if (type === 'cable') {
        itemTitle = '<div class="item-title">Solar Panel Cable</div>';
      }
      const imageHtml = imageUrl 
        ? `<img src="${imageUrl}" alt="${name}" class="item-image">`
        : '';
      const infoText = `<div class="item-details"><span class="item-names">${imageHtml} <span>${name}<span class="item-price">${pricePart}</span></span></span><span class="item-number"> ×${quantity}</span></div>`;

      return `
        <div class="item-line">
          ${itemTitle}
          <div class="item-info">
            ${infoText}
            <form class="item-form" action="/cart/add" method="post">
              <input type="hidden" name="id" value="${variantId}" />
              <input type="hidden" name="quantity" value="${quantity}" />
              <button type="submit" class="item-to-cart" title="Add to cart">
                <span class="cart-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M12.5 17h-6.5v-14h-2" /><path d="M6 5l14 1l-.86 6.017m-2.64 .983h-10.5" /><path d="M16 19h6" /><path d="M19 16v6" /></svg></span>
                  <span class="loading__spinner hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                  </span>
              </button>
            </form>
          </div>
        </div>
      `;
    }

    panelTypeSelect.addEventListener('change', function () {
      const selectedType = this.value;
      updatePanelQty(selectedType);
    });

    panelQtySelect.addEventListener('change', function () {
      const panelType = panelTypeSelect.value;
      lastSelectedQty[panelType] = this.value;
      renderResult();
    });

    container.addEventListener('click', function(e){
      const button = e.target.closest('.item-to-cart');
      if (!button) return;

      e.preventDefault();
      const form = button.closest('.item-form');
      if (form) {
        addToCartFromForm(form, button);
      }
    });

    initPanelType();
  });

})();